import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { FaLinkedinIn, FaGithub, FaYoutube, FaInstagram, FaFacebookF } from 'react-icons/fa'
import { SiResearchgate } from 'react-icons/si'
import { translations } from '../../i18n'
import Loader from '../../components/Loader'

const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '')

function ContactsSection() {
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, contact } = useSelector(s => s.rootReducer.contactRed)

  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' })
  const [status, setStatus] = useState('idle') // idle | sending | success | error
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    if (status === 'success') {
      const t = setTimeout(() => setStatus('idle'), 6000)
      return () => clearTimeout(t)
    }
  }, [status])

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value })

  const handleSubmit = async e => {
    e.preventDefault()
    const { name, email, subject, message } = form
    if (!name || !email || !subject || !message) {
      setErrorMsg(T.contacts.form_required)
      setStatus('error')
      return
    }
    setStatus('sending')
    setErrorMsg('')
    try {
      const res = await fetch(`${API_BASE}/api/portfolio/contact/send/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      })
      if (res.ok) {
        setStatus('success')
        setForm({ name: '', email: '', subject: '', message: '' })
      } else {
        const data = await res.json()
        setErrorMsg(data.error || T.contacts.form_error)
        setStatus('error')
      }
    } catch {
      setErrorMsg(T.contacts.form_error)
      setStatus('error')
    }
  }

  if (loading) return <section id='contacts' className='fc-section bg-alt'><Container><Loader /></Container></section>
  if (!contact) return null

  return (
    <section id='contacts' className='fc-section bg-alt'>
      <Container>
        <h2 className='section-title'>{T.sections.contacts}</h2>
        <Row className='justify-content-center'>
          <Col md={8} lg={6}>
            <div className='contact-card'>
              <div className='contact-label' style={{ marginBottom: '.5rem' }}>{T.contacts.find_me}</div>
              <div className='social-row' style={{ marginTop: 0, marginBottom: '2rem' }}>
                {contact.linkedin_url && (
                  <a href={contact.linkedin_url} target='_blank' rel='noreferrer' className='social-link social-link--linkedin' title='LinkedIn'>
                    <FaLinkedinIn size={20} />
                  </a>
                )}
                {contact.github_url && (
                  <a href={contact.github_url} target='_blank' rel='noreferrer' className='social-link social-link--github' title='GitHub'>
                    <FaGithub size={20} />
                  </a>
                )}
                {contact.researchgate_url && (
                  <a href={contact.researchgate_url} target='_blank' rel='noreferrer' className='social-link social-link--researchgate' title='ResearchGate'>
                    <SiResearchgate size={20} />
                  </a>
                )}
                {contact.youtube_url && (
                  <a href={contact.youtube_url} target='_blank' rel='noreferrer' className='social-link social-link--youtube' title='YouTube'>
                    <FaYoutube size={20} />
                  </a>
                )}
                {contact.instagram_url && (
                  <a href={contact.instagram_url} target='_blank' rel='noreferrer' className='social-link social-link--instagram' title='Instagram'>
                    <FaInstagram size={20} />
                  </a>
                )}
                {contact.facebook_url && (
                  <a href={contact.facebook_url} target='_blank' rel='noreferrer' className='social-link social-link--facebook' title='Facebook'>
                    <FaFacebookF size={20} />
                  </a>
                )}
              </div>

              <p style={{ color: 'var(--muted)', marginBottom: '1.5rem' }}>{T.contacts.message}</p>

              <form onSubmit={handleSubmit} noValidate>
                <div className='contact-form-group'>
                  <label className='contact-label'>{T.contacts.form_name}</label>
                  <input
                    className='contact-input'
                    type='text' name='name' value={form.name}
                    onChange={handleChange} disabled={status === 'sending'}
                  />
                </div>
                <div className='contact-form-group'>
                  <label className='contact-label'>{T.contacts.form_email}</label>
                  <input
                    className='contact-input'
                    type='email' name='email' value={form.email}
                    onChange={handleChange} disabled={status === 'sending'}
                  />
                </div>
                <div className='contact-form-group'>
                  <label className='contact-label'>{T.contacts.form_subject}</label>
                  <input
                    className='contact-input'
                    type='text' name='subject' value={form.subject}
                    onChange={handleChange} disabled={status === 'sending'}
                  />
                </div>
                <div className='contact-form-group'>
                  <label className='contact-label'>{T.contacts.form_message}</label>
                  <textarea
                    className='contact-input contact-textarea'
                    name='message' value={form.message} rows={5}
                    onChange={handleChange} disabled={status === 'sending'}
                  />
                </div>

                {status === 'success' && (
                  <div className='contact-feedback contact-feedback--success'>{T.contacts.form_success}</div>
                )}
                {status === 'error' && (
                  <div className='contact-feedback contact-feedback--error'>{errorMsg || T.contacts.form_error}</div>
                )}

                <button
                  type='submit'
                  className='hero-btn hero-btn-primary'
                  disabled={status === 'sending' || status === 'success'}
                  style={{ marginTop: '1rem' }}
                >
                  {status === 'sending' ? T.contacts.form_sending : T.contacts.form_submit}
                </button>
              </form>

            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ContactsSection
